import { c as _c } from "react/compiler-runtime";
import type { PaginationState } from '@tanstack/react-table';
import { useState } from 'react';
interface UsePaginationProps {
  defaultPageSize?: number;
}

/**
 * Hook for managing table pagination state.
 * @param params - Configuration object
 * @param params.defaultPageSize - Number of items per page (defaults to 25)
 * @returns Pagination state with first/skip values, handlers, and reset function
 */
export const usePagination = t0 => {
  const $ = _c(9);
  const {
    defaultPageSize: t1
  } = t0;
  const defaultPageSize = t1 === undefined ? 25 : t1;
  let t2;
  if ($[0] !== defaultPageSize) {
    t2 = {
      pageIndex: 0,
      pageSize: defaultPageSize
    };
    $[0] = defaultPageSize;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [pagination, setPagination] = useState(t2);
  const first = pagination.pageSize;
  const skip = pagination.pageIndex * pagination.pageSize;
  let t3;
  if ($[2] !== defaultPageSize) {
    t3 = () => {
      setPagination({
        pageIndex: 0,
        pageSize: defaultPageSize
      });
    };
    $[2] = defaultPageSize;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const reset = t3;
  let t4;
  if ($[4] !== first || $[5] !== pagination || $[6] !== reset || $[7] !== skip) {
    t4 = {
      first,
      skip,
      pagination,
      onPaginationChange: setPagination,
      reset
    };
    $[4] = first;
    $[5] = pagination;
    $[6] = reset;
    $[7] = skip;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};